import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { HttpServerLinkedService } from 'app/model/linkedservice/http-server.linkedservice';
import { FileTypeDataset } from 'app/model/dataset/file-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.httpServer.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.HttpServer_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.HttpServer_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: HttpServerLinkedService.MODEL // Linked service redefined
        }
    }
})
export class HttpFileDataset extends FileTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly URL: IAttribute;
    public static readonly METHOD: IAttribute;
    public static readonly HEADER: IAttribute;
    public static readonly BODY: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'URL',
        display: stringResources.Dataset_RelativeUrl
    })
    public relativeUrl?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'METHOD',
        display: stringResources.Dataset_RequestMethod
    })
    public requestMethod?: string = 'GET';

    @Metamodel.attribute({
        templatable: true,
        association: 'HEADER',
        display: stringResources.Dataset_AdditionalHeaders
    })
    public additionalHeaders?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'BODY',
        display: stringResources.Dataset_RequestBody
    })
    public requestBody?: string;
}
